import { jsxs, jsx } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { useGraphiQLActions, Dialog, Button } from "@graphiql/react";
import { useCollectionsStore, collectionsStore } from "../store.js";
const NEW_COLLECTION = "__new__";
const SaveDialog = () => {
  const collections = useCollectionsStore((s) => s.collections);
  const actions = useCollectionsStore((s) => s.actions);
  const { open, name: initialName } = useCollectionsStore((s) => s.saveDialog);
  const { markTabSaved } = useGraphiQLActions();
  const [name, setName] = useState(initialName);
  const [description, setDescription] = useState("");
  const [selectedCollectionId, setSelectedCollectionId] = useState(NEW_COLLECTION);
  const [newCollectionName, setNewCollectionName] = useState("New Collection");
  useEffect(() => {
    var _a;
    if (open) {
      const { collections: current } = collectionsStore.getState();
      setName(initialName);
      setDescription("");
      setSelectedCollectionId(((_a = current[0]) == null ? void 0 : _a.id) ?? NEW_COLLECTION);
      setNewCollectionName("New Collection");
    }
  }, [open, initialName]);
  const handleSave = () => {
    const { saveDialog, actions: a } = collectionsStore.getState();
    let collectionId = selectedCollectionId;
    if (selectedCollectionId === NEW_COLLECTION) {
      collectionId = a.createCollection(
        newCollectionName || "New Collection"
      ).id;
    }
    const item = a.addItem(collectionId, {
      name: name || "Unnamed operation",
      description: description || void 0,
      query: saveDialog.query,
      variables: saveDialog.variables,
      headers: saveDialog.headers
    });
    if (saveDialog.tabId) {
      a.linkTab(saveDialog.tabId, collectionId, item.id);
      markTabSaved(saveDialog.tabId);
    }
    a.closeSaveDialog();
  };
  return /* @__PURE__ */ jsxs(Dialog, { open, onOpenChange: (o) => !o && actions.closeSaveDialog(), children: [
    /* @__PURE__ */ jsx(Dialog.Header, { children: "Save to collection" }),
    /* @__PURE__ */ jsxs(
      "form",
      {
        onSubmit: (e) => {
          e.preventDefault();
          handleSave();
        },
        children: [
          /* @__PURE__ */ jsxs(Dialog.Body, { children: [
            /* @__PURE__ */ jsxs("label", { className: "graphiql-save-dialog-field", children: [
              /* @__PURE__ */ jsx("span", { children: "Operation name" }),
              /* @__PURE__ */ jsx(
                "input",
                {
                  type: "text",
                  value: name,
                  onChange: (e) => setName(e.target.value),
                  placeholder: "Unnamed operation",
                  className: "graphiql-save-dialog-input",
                  autoFocus: true
                }
              )
            ] }),
            /* @__PURE__ */ jsxs("label", { className: "graphiql-save-dialog-field", children: [
              /* @__PURE__ */ jsx("span", { children: "Description" }),
              /* @__PURE__ */ jsx(
                "input",
                {
                  type: "text",
                  value: description,
                  onChange: (e) => setDescription(e.target.value),
                  placeholder: "Description (optional)",
                  className: "graphiql-save-dialog-input"
                }
              )
            ] }),
            /* @__PURE__ */ jsxs("label", { className: "graphiql-save-dialog-field", children: [
              /* @__PURE__ */ jsx("span", { children: "Collection" }),
              /* @__PURE__ */ jsxs(
                "select",
                {
                  value: selectedCollectionId,
                  onChange: (e) => setSelectedCollectionId(e.target.value),
                  className: "graphiql-save-dialog-select",
                  children: [
                    /* @__PURE__ */ jsx("option", { value: NEW_COLLECTION, children: "+ New collection" }),
                    collections.map((c) => /* @__PURE__ */ jsx("option", { value: c.id, children: c.name }, c.id))
                  ]
                }
              )
            ] }),
            selectedCollectionId === NEW_COLLECTION && /* @__PURE__ */ jsxs("label", { className: "graphiql-save-dialog-field", children: [
              /* @__PURE__ */ jsx("span", { children: "Collection name" }),
              /* @__PURE__ */ jsx(
                "input",
                {
                  type: "text",
                  value: newCollectionName,
                  onChange: (e) => setNewCollectionName(e.target.value),
                  placeholder: "Collection name",
                  className: "graphiql-save-dialog-input"
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ jsxs(Dialog.Footer, { children: [
            /* @__PURE__ */ jsx(Button, { type: "button", onClick: () => actions.closeSaveDialog(), children: "Cancel" }),
            /* @__PURE__ */ jsx(Button, { type: "submit", variant: "primary", children: "Save" })
          ] })
        ]
      }
    )
  ] });
};
export {
  SaveDialog
};
//# sourceMappingURL=save-dialog.js.map
